export default "__VITE_ASSET__BFLoPOnb__"